import { Component, Input, OnInit } from '@angular/core';
import { NavController, AlertController, LoadingController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { RestaurantService } from 'src/app/core/services/restaurant.service';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { UtilsService } from 'src/app/core/services/utils.service'

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {

  email: string = ''
  restaurantUrl: string
  isNewHomePedirDelivery: boolean

  @Input() backToLoginFn?: () => void;

  constructor(private navCtrl: NavController,
              private authService: AuthenticationService,
              private actRoute: ActivatedRoute,
              private restaurantService: RestaurantService,
              private alertController: AlertController,
              private loadingController: LoadingController,
              private translatePipe: TranslatePipe,
              private utils: UtilsService,
  ) { }

  ngOnInit() {
    this.restaurantUrl = this.actRoute.snapshot.params.restaurant
    if(!this.restaurantService.loaded){
      this.restaurantService.loadByURL(this.restaurantUrl)
    }
    this.isNewHomePedirDelivery = !!this.restaurantService.restaurant?.info?.modules?.new_home_pedir_delivery;
  }

  backToLogin(){
    if (this.backToLoginFn) {
      this.backToLoginFn();
      return;
    }
    const nav = document.querySelector('ion-nav');
    if (nav) {
      return nav.pop();
    }
    this.navCtrl.navigateBack(`${this.restaurantUrl}/login`);
  }

  async forgotPassword() {
		const loading = await this.loadingController.create({
			message: `${this.translatePipe.transform('Wait')}...`
		})
    await loading.present()

    this.authService.forgotPassword({email: this.email}).then((_response: unknown) => {
      loading.dismiss()
      this.pageForgotPasswordAlert(this.translatePipe.transform("Sent with success!"))
    }).catch((error: { error: string }) => {
      if (error.error == 'Email is required!') {
        loading.dismiss()
        this.pageForgotPasswordAlert(this.translatePipe.transform("Email is required!"))
      } else if(error.error == 'Email does not exist!'){
        loading.dismiss()
        this.pageForgotPasswordAlert(this.translatePipe.transform("Email does not exist!"))
      }
    })
  }

  async pageForgotPasswordAlert(message: string) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: message,
      buttons: ['OK']
    });

    await alert.present();
  }
}
